import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { createStoreWithSelectors } from 'common/util/zustand';
export const polygonsStore = create(subscribeWithSelector((set, get) => ({
    polygons: [],
    setPolygons: (polygons) => {
        const nPolygons = polygons.map((polygon) => {
            //clone props. Need to save original Coordinates for Undo action
            polygon.originalState = {
                Coordinates: JSON.parse(JSON.stringify(polygon.Coordinates)),
                Properties: JSON.parse(JSON.stringify(polygon.Properties))
            };
            return polygon;
        });
        set(() => ({ polygons: nPolygons }));
    },
    community: null,
    setCommunity: (community) => {
        set(() => ({ community: community }));
    }
})));
const usePolygonsStore = createStoreWithSelectors(polygonsStore);
export default usePolygonsStore;
